import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button, Radio,
  Input, Select, Upload, DatePicker,
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import history from 'utils/history'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from 'moment'
// import Helper from 'utils/Helper'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormNews = ({
  handleSubmit, isEdit, isSubmit,
  handleUpload, imgFile, data,
  categoryList, newsContent, handleChangeEditor, setNewsContent
}) => {
  const [form] = Form.useForm()
  const formRef = React.createRef()


  useEffect(() => {
    if (isEdit && data) {
      form.setFieldsValue({
        title: data?.title || '',
        excerpt: data?.excerpt || '',
        published_at: moment(data?.published_at),
        expired_at: moment(data?.expired_at),
        category_id: data?.category?.id,
        status: data?.status || 'inactive',
        is_top: data?.is_top || false,
        content: data?.content || '',
        slideshow: data?.slideshow || 0,
      })
      setNewsContent(data?.content)
    }
  }, [data])

  useEffect(() => {
    formRef.current.setFieldsValue({
      content: newsContent,
    })
  }, [newsContent])

  const validateMessages = {
    required: "'${label}' wajib diisi!", // eslint-disable-line no-template-curly-in-string
  }

  return (
    <div>
      <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
        <h3 className="title-content mb-0">
          {isEdit ? 'Ubah' : 'Tambah'}
          {' '}
          Berita
        </h3>
      </div>
      <Card className="pt-4">
        <Form
          {...formItemLayout}
          form={form}
          ref={formRef}
          name="news"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Form.Item label="Judul" name="title" rules={[{ required: true }]}>
            <Input placeholder="Judul" />
          </Form.Item>

          <Form.Item label="Kategori" name="category_id" rules={[{ required: true }]}>
            <Select
              placeholder="Pilih Kategori"
              allowClear
            >
              {(categoryList.data || []).map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
            </Select>
          </Form.Item>

          <Form.Item name="excerpt" label="Deskripsi Singkat" rules={[{ required: true }]}>
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item
            label="Konten"
            name="content"
            rules={[{ required: true }]}
          >
            <CKEditor
              name="newsContent"
              editor={ ClassicEditor }
              data={newsContent}
              onChange={ ( event, editor ) => {
                const data = editor.getData();
                handleChangeEditor(data)
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                writer.setStyle(
                    "height",
                    "200px",
                    editor.editing.view.document.getRoot()
                );
                });
              }}
            />
          </Form.Item>

          <Form.Item
            name="image"
            label="Gambar"
            valuePropName="imageFile"
            extra="Ukuran maksimal 1 MB"
            getValueFromEvent={handleUpload}
          >
            <Upload
              showUploadList={false}
              beforeUpload={() => false}
            >
              <React.Fragment>
                {imgFile && (
                  <img src={imgFile} className="icon-thumbnail-form mb-3" alt="Gambar Berita" />
                )}
                <div>
                  <Button icon={<UploadOutlined />}>Klik untuk unggah</Button>
                </div>
              </React.Fragment>
            </Upload>
          </Form.Item>

          <Form.Item
            name="published_at"
            label="Tanggal Mulai Tayang"
            rules={[{ required: true }]}
          >
            <DatePicker showTime />
          </Form.Item>

          <Form.Item
            name="expired_at"
            label="Tanggal Akhir Tayang"
            rules={[{ required: true }]}
          >
            <DatePicker showTime />
          </Form.Item>

          <Form.Item
            name="is_top"
            label="Letakan Paling Atas"
            rules={[{ required: true }]}
            initialValue={false}
          >
            <Radio.Group>
              <Radio value>Ya</Radio>
              <Radio value={false}>Tidak</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="status"
            label="Status"
            rules={[{ required: true }]}
            initialValue="inactive"
          >
            <Radio.Group>
              <Radio value="active">Aktif</Radio>
              <Radio value="inactive">Inaktif</Radio>
            </Radio.Group>
          </Form.Item>
          
          <Form.Item
            name="slideshow"
            label="Tampilkan pada Slideshow"
            rules={[{ required: true }]}
            initialValue={false}
          >
            <Radio.Group>
              <Radio value={1}>Ya</Radio>
              <Radio value={0}>Tidak</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn-primary-wrapper text-right">
            <Button onClick={() => window.history.back()} className="m-r-10" style={{ display: 'inline-block' }}>Batal</Button>
            <Button type="primary" loading={isSubmit} htmlType="submit">{isEdit ? 'Kirim Perubahan' : 'Buat'}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

FormNews.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  isEdit: PropTypes.bool,
  handleUpload: PropTypes.func,
  imgFile: PropTypes.any,
  data: PropTypes.object,
  categoryList: PropTypes.object,
  newsContent: PropTypes.string,
  handleChangeEditor: PropTypes.func,
}

export default FormNews
